import { defineMessages } from 'react-intl';

export const tableMessages = defineMessages({
    entries: { id: 'entries', defaultMessage: 'Entries' },
    searchEntries: { id: 'search-entries', defaultMessage: 'Search for {entries}...' },
    searchByFields: { id: 'search-by-fields', defaultMessage: 'Search by {fields}.' },
    search: { id: 'search', defaultMessage: 'Search' },
    ok: { id: 'ok', defaultMessage: 'OK' },
    searchInfo: { id: 'search-info', defaultMessage: 'Searchable fields' },
    view: { id: 'view', defaultMessage: 'View' },
    hide: { id: 'hide', defaultMessage: 'Hide' },
    ascending: { id: 'ascending', defaultMessage: 'Ascending' },
    descending: { id: 'descending', defaultMessage: 'Descending' },
    orderAscending: { id: 'order-ascending', defaultMessage: 'Order ascending' },
    orderDescending: { id: 'order-descending', defaultMessage: 'Order descending' },
    viewOptions: { id: 'view-options', defaultMessage: 'View options' },
    viewEnableAll: { id: 'enable-all', defaultMessage: 'Enable all' },
    filters: { id: 'filters', defaultMessage: 'Filters' },
    addFilter: { id: 'add-filter', defaultMessage: 'Add filter' },
    page: { id: 'page', defaultMessage: 'Page' },
    of: { id: 'of', defaultMessage: 'of' },
    new: { id: 'new-entry', defaultMessage: 'New {entry}' },
    perPage: { id: 'per-page', defaultMessage: 'Per page' },
    noFilterApplied: { id: 'no-filter-applied', defaultMessage: 'No filter' },
    noResults: { id: 'no-results', defaultMessage: 'No results found' },
    noResultsSubtitle: {
        id: 'no-results-subtitle',
        defaultMessage: `There are currently no {entries} in this table. \n Try creating some new ones`,
    },
    noResultsSubtitleFilters: {
        id: 'no-results-subtitle-filters',
        defaultMessage: `Your applied filters have no results. \nTry tweaking the applied filters`,
    },
    noResultsSubtitleSearch: {
        id: 'no-results-subtitle-search',
        defaultMessage: `Your search for "{search}" has no results. \nTry searching for something else`,
    },
    filterByColumn: { id: 'filter-by-column', defaultMessage: 'Filter by column' },
    clearFilter: { id: 'clear-filter', defaultMessage: 'Remove filter' },
    filterColumnTitle: { id: 'filter-column-title', defaultMessage: 'Filter "{column}" column' },
    from: { id: 'from', defaultMessage: 'From' },
    to: { id: 'to', defaultMessage: 'To' },
    applyMassAction: { id: 'apply-mass-action', defaultMessage: 'Apply mass action' },
    applyMassActionOptions: { id: 'apply-mass-action-options', defaultMessage: 'Mass action options' },
    selectedCountEntries: {
        id: 'selected-count-entries',
        defaultMessage:
            '{count, plural, =0 {No entries selected} one {Selected {count, number} entry} other {Selected {count, number} entries}}',
    },
});
